/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponseData;

  constructor(
    err: PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse";
  }
}

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$inboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse(v);
    });

/** @internal */
export type PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$outboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$Outbound,
    z.ZodTypeDef,
    PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse
  > = z.instanceof(PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$ {
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$inboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$outboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$Outbound` instead. */
  export type Outbound =
    PutApiLeadScraperMicroserviceApiV1WorkspaceErrorResponse$Outbound;
}
